export default [
  {
    path: '/customer-discount',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: '',
        name: 'customer-discount',
        component: () => import('@/pages/Assets/customerDiscount/List.vue'),
        meta: {
          pageTitle: 'customerDiscountTransaction',
          breadcrumb: [{ text: 'assets', active: true }],
          permission: 'viewCustomerDiscountTransactions',
        },
      },
      {
        path: 'new',
        name: 'customer-discount-new',
        component: () => import('@/pages/Assets/customerDiscount/Edit.vue'),
        meta: {
          pageTitle: 'customerDiscountNew',
          breadcrumb: [
            { text: 'assets', active: true },
            { text: 'customer-discount', active: true },
          ],
          permission: 'addCustomerDiscountTransactions',
        },
      },
      {
        path: 'edit/:id',
        name: 'customer-discount-edit',
        props: true,
        component: () => import('@/pages/Assets/customerDiscount/Edit.vue'),
        meta: {
          pageTitle: 'customerDiscountEdit',
          breadcrumb: [
            { text: 'assets', active: true },
            { text: 'customer-discount', active: true },
          ],
          permission: 'editCustomerDiscountTransactions',
        },
      },
    ],
  },
  {
    path: '/supplier-discount',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: '',
        name: 'supplier-discount',
        component: () => import('@/pages/Assets/supplierDiscount/List.vue'),
        meta: {
          pageTitle: 'Supplier Discount Transaction',
          breadcrumb: [{ text: 'assets', active: true }],
          permission: 'viewSupplierDiscountTransactions',
        },
      },
      {
        path: 'new',
        name: 'supplier-discount-new',
        component: () => import('@/pages/Assets/supplierDiscount/Edit.vue'),
        meta: {
          pageTitle: 'supplierDiscountNew',
          breadcrumb: [
            { text: 'assets', active: true },
            { text: 'supplier-discount', active: true },
          ],
          permission: 'addSupplierDiscountTransactions',
        },
      },
      {
        path: 'edit/:id',
        name: 'supplier-discount-edit',
        props: true,
        component: () => import('@/pages/Assets/supplierDiscount/Edit.vue'),
        meta: {
          pageTitle: 'supplierDiscountEdit',
          breadcrumb: [
            { text: 'assets', active: true },
            { text: 'supplier-discount', active: true },
          ],
          permission: 'editSupplierDiscountTransactions',
        },
      },
    ],
  },
  {
    path: '/collection-transactions',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: '',
        name: 'collection-transactions',
        component: () => import('@/pages/Assets/collectionTransactions/List.vue'),
        meta: {
          pageTitle: 'Collection Transaction',
          breadcrumb: [{ text: 'assets', active: true }],
          permission: 'viewCollectionTransactions',
        },
      },
      {
        path: 'new',
        name: 'collection-transactions-new',
        component: () => import('@/pages/Assets/collectionTransactions/Edit.vue'),
        meta: {
          pageTitle: 'collection-transactions-new',
          breadcrumb: [
            { text: 'assets', active: true },
            { text: 'Collection Transaction', active: true },
          ],
          permission: 'addCollectionTransactions',
        },
      },
      {
        path: 'edit/:id',
        name: 'collection-transactions-edit',
        props: true,
        component: () => import('@/pages/Assets/collectionTransactions/Edit.vue'),
        meta: {
          pageTitle: 'collection-transactions-edit',
          breadcrumb: [
            { text: 'assets', active: true },
            { text: 'Collection Transaction', active: true },
          ],
          permission: 'editCollectionTransactions',
        },
      },
    ],
  },
  {
    path: '/payment-transactions',
    name: 'payment-transactions',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: '',
        name: 'payment-transactions',
        component: () => import('@/pages/Assets/paymentTransactions/List.vue'),
        meta: {
          pageTitle: 'paymentTransaction',
          breadcrumb: [{
            text: 'assets',
            active: true
          }],
          permission: 'viewPaymentTransactions',
        },
      },
      {
        path: 'new',
        name: 'payment-transactions-new',
        component: () => import('@/pages/Assets/paymentTransactions/Edit.vue'),
        meta: {
          pageTitle: 'payment-transactions-new',
          breadcrumb: [
            { text: 'assets', active: true },
            { text: 'paymentTransaction', active: true },
          ],
          permission: 'addPaymentTransactions',
        },
      },
      {
        path: 'edit/:id',
        name: 'payment-transactions-edit',
        props: true,
        component: () => import('@/pages/Assets/paymentTransactions/Edit.vue'),
        meta: {
          pageTitle: 'payment-transactions-edit',
          breadcrumb: [
            { text: 'assets', active: true },
            { text: 'PaymentTransaction', active: true },
          ],
          permission: 'editPaymentTransactions',
        },
      },
    ],
  },
  {
    path: '/income-transactions',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: '',
        name: 'income-transactions',
        component: () => import('@/pages/Assets/incomeTransaction/List.vue'),
        meta: {
          pageTitle: 'Income Transaction',
          breadcrumb: [{ text: 'assets', active: true }],
          permission: 'viewIncomeTransactions',
        },
      },
      {
        path: 'new',
        name: 'income-transactions-new',
        component: () => import('@/pages/Assets/incomeTransaction/Edit.vue'),
        meta: {
          pageTitle: 'income-transactions-new',
          breadcrumb: [
            { text: 'assets', active: true },
            { text: 'Income Transaction', active: true },
          ],
          permission: 'addIncomeTransactions',
        },
      },
      {
        path: 'edit/:id',
        name: 'income-transactions-edit',
        props: true,
        component: () => import('@/pages/Assets/incomeTransaction/Edit.vue'),
        meta: {
          pageTitle: 'income-transactions-edit',
          breadcrumb: [
            { text: 'assets', active: true },
            { text: 'Income Transaction', active: true },
          ],
          permission: 'editIncomeTransactions',
        },
      },
    ],
  },
  {
    path: '/expense-transactions',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: '',
        name: 'expense-transactions',
        component: () => import('@/pages/Assets/expenseTransaction/List.vue'),
        meta: {
          pageTitle: 'expenseTransaction',
          breadcrumb: [{ text: 'assets', active: true }],
          permission: 'viewExpenseTransactions',
        },
      },
      {
        path: 'new',
        name: 'expense-transactions-new',
        component: () => import('@/pages/Assets/expenseTransaction/Edit.vue'),
        meta: {
          pageTitle: 'expense-transactions-new',
          breadcrumb: [
            { text: 'assets', active: true },
            { text: 'expenseTransaction', active: true },
          ],
          permission: 'addExpenseTransactions',
        },
      },
      {
        path: 'edit/:id',
        name: 'expense-transactions-edit',
        props: true,
        component: () => import('@/pages/Assets/expenseTransaction/Edit.vue'),
        meta: {
          pageTitle: 'expense-transactions-edit',
          breadcrumb: [
            { text: 'assets', active: true },
            { text: 'expenseTransaction', active: true },
          ],
          permission: 'editExpenseTransactions',
        },
      },
    ],
  },
  {
    path: '/transfers-and-settlements',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: '',
        name: 'transfers-and-settlements',
        component: () => import('@/pages/Assets/TransfersAndSettlements/List.vue'),
        meta: {
          pageTitle: 'transfersAndSettlements',
          breadcrumb: [{ text: 'assets', active: true }],
          permission: 'viewTransfersAndSettlements',
        },
      },
      {
        path: 'new',
        name: 'transfers-and-settlements-new',
        component: () => import('@/pages/Assets/TransfersAndSettlements/Edit.vue'),
        meta: {
          pageTitle: 'transfers-and-settlements-new',
          breadcrumb: [
            { text: 'assets', active: true },
            { text: 'transfersAndSettlements', active: true },
          ],
          permission: 'addTransfersAndSettlements',
        },
      },
      {
        path: 'edit/:id',
        name: 'transfers-and-settlements-edit',
        props: true,
        component: () => import('@/pages/Assets/TransfersAndSettlements/Edit.vue'),
        meta: {
          pageTitle: 'transfers-and-settlements-edit',
          breadcrumb: [
            { text: 'assets', active: true },
            { text: 'transfersAndSettlements', active: true },
          ],
          permission: 'editTransfersAndSettlements',
        },
      },
    ],
  },
  {
    path: '/shortage-adjustment',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: '',
        name: 'shortage-adjustment',
        component: () => import('@/pages/Stores/shortageAdjustment/List.vue'),
        meta: {
          pageTitle: 'shortageAdjustment',
          breadcrumb: [{ text: 'inventory-wharehous', active: true }],
          permission: 'viewShortageAdjustments',
        },
      },
      {
        path: 'new',
        name: 'shortage-adjustment-new',
        component: () => import('@/pages/Stores/shortageAdjustment/Edit.vue'),
        meta: {
          pageTitle: 'shortageAdjustmentNew',
          breadcrumb: [
            { text: 'inventory-wharehous', active: true },
            { text: 'shortageAdjustment', active: true },
          ],
          permission: 'addShortageAdjustments',
        },
      },
      {
        path: 'edit/:id',
        name: 'shortage-adjustment-edit',
        props: true,
        component: () => import('@/pages/Stores/shortageAdjustment/Edit.vue'),
        meta: {
          pageTitle: 'shortageAdjustmentEdit',
          breadcrumb: [
            { text: 'inventory-wharehous', active: true },
            { text: 'shortageAdjustment', active: true },
          ],
          permission: 'editShortageAdjustments',
        },
      },
    ],
  },
  {
    path: '/orders',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: '',
        name: 'orders',
        component: () => import('@/pages/Stores/Orders/List.vue'),
        meta: {
          pageTitle: 'orders',
          breadcrumb: [{ text: 'Stores', active: true }],
          permission: 'viewStockCategoryTransactions',
        },
      },
    ],
  },
  {
    path: '/storage-transfer',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: '',
        name: 'storage-transfer',
        component: () => import('@/pages/Stores/storageTransfer/List.vue'),
        meta: {
          pageTitle: 'storageTransfer',
          breadcrumb: [{ text: 'Stores', active: true }],
          permission: 'viewStorageTransfer',
        },
      },
      {
        path: 'new',
        name: 'storage-transfer-new',
        component: () => import('@/pages/Stores/storageTransfer/Edit.vue'),
        meta: {
          pageTitle: 'storageTransferNew',
          breadcrumb: [{ text: 'Stores', active: true }],
          permission: 'addStorageTransfer',
        },
      },
      {
        path: 'edit/:id',
        name: 'storage-transfer-edit',
        props: true,
        component: () => import('@/pages/Stores/storageTransfer/Edit.vue'),
        meta: {
          pageTitle: 'storageTransferEdit',
          breadcrumb: [{ text: 'Stores', active: true }],
          permission: 'editStorageTransfer',
        },
      },
    ],
  },
  {
    path: '/storage-transfer-acceptance',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: '',
        name: 'storage-transfer-acceptance',
        component: () => import('@/pages/Stores/storageTransferAcceptance/List.vue'),
        meta: {
          pageTitle: 'storageTransferAcceptance',
          breadcrumb: [{ text: 'Stores', active: true }],
          permission: 'viewStorageTransferAcceptance',
        },
      },
      {
        path: 'edit/:id',
        name: 'storage-transfer-acceptance-edit',
        props: true,
        component: () => import('@/pages/Stores/storageTransferAcceptance/Edit.vue'),
        meta: {
          pageTitle: 'storageTransferAcceptance',
          breadcrumb: [{ text: 'Stores', active: true }],
          permission: 'viewStorageTransferAcceptance',
        },
      },
    ],
  },
  {
    path: '/damage-adjustment',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: '',
        name: 'damage-adjustment',
        component: () => import('@/pages/Stores/damgeAdjustment/List.vue'),
        meta: {
          pageTitle: 'damageAdjustment',
          breadcrumb: [{ text: 'Stores', active: true }],
          permission: 'viewDamageAdjustments',
        },
      },
      {
        path: 'new',
        name: 'damage-adjustment-new',
        component: () => import('@/pages/Stores/damgeAdjustment/Edit.vue'),
        meta: {
          pageTitle: 'damageAdjustmentNew',
          breadcrumb: [
            { text: 'Stores', active: true },
            { text: 'damageAdjustment', active: true },
          ],
          permission: 'addDamageAdjustments',
        },
      },
      {
        path: 'edit/:id',
        name: 'damage-adjustment-edit',
        props: true,
        component: () => import('@/pages/Stores/damgeAdjustment/Edit.vue'),
        meta: {
          pageTitle: 'damageAdjustmentEdit',
          breadcrumb: [
            { text: 'Stores', active: true },
            { text: 'damageAdjustment', active: true },
          ],
          permission: 'editDamageAdjustments',
        },
      },
    ],
  },
  {
    path: '/overflow-adjustment',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: '',
        name: 'overflow-adjustment',
        component: () => import('@/pages/Stores/OverflowAdjustment/List.vue'),
        meta: {
          pageTitle: 'overflowAdjustment',
          breadcrumb: [{ text: 'inventory-wharehous', active: true }],
          permission: 'viewOverflowAdjustments',
        },
      },
      {
        path: 'new',
        name: 'overflow-adjustment-new',
        component: () => import('@/pages/Stores/OverflowAdjustment/Edit.vue'),
        meta: {
          pageTitle: 'overflowAdjustmentNew',
          breadcrumb: [
            { text: 'inventory-wharehous', active: true },
            { text: 'overflowAdjustment', active: true },
          ],
          permission: 'addOverflowAdjustments',
        },
      },
      {
        path: 'edit/:id',
        name: 'overflow-adjustment-edit',
        props: true,
        component: () => import('@/pages/Stores/OverflowAdjustment/Edit.vue'),
        meta: {
          pageTitle: 'overflowAdjustmentEdit',
          breadcrumb: [
            { text: 'inventory-wharehous', active: true },
            { text: 'overflowAdjustment', active: true },
          ],
          permission: 'editOverflowAdjustments',
        },
      },
    ],
  },
];
